module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cpytxta"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Copyright © 2012 Agate Publishing, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_c('span', [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording, or by any information storage or retrieval system without express written permission from the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Cover photo © Brave New Pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Food Stylist: Mary Valentin")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Photos on the following pages from Shutterstock: 4, 10, 13, 16, 17, 18, 19, 20, 24, 36, 46, 56, 70, 84, 96, 102, 114, 124.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Photos on the following pages from Brave New Pictures: 29, 43, 53, 61, 67, 75, 79, 93, 109, 119, 129, 143.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("First ebook edition 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("ISBN-13 978-1-57284-695-1")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("The Library of Congress has cataloged the flexibound edition of this book as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_c('span', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Diabetes cooking 101 : master diabetes cooking with 101 great recipes / edited by Perrin Davis.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxti"
  }, [_c('span', [_vm._v("p. cm.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtx"
  }, [_c('span', [_vm._v("Includes index.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtx"
  }, [_c('span', [_vm._v("ISBN-13: 978-1-57284-695-1 (ebook)")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtx"
  }, [_c('span', [_vm._v("1. Diabetes--Diet therapy--Recipes. 2. Cookbooks. I. Davis, Perrin, 1969-")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtx1"
  }, [_c('span', [_vm._v("RC662.D5215 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtx"
  }, [_c('span', [_vm._v("641.56314--dc23")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtx2"
  }, [_c('span', [_vm._v("2011039678")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtxa"
  }, [_c('span', [_vm._v("Surrey Books is an imprint of Agate Publishing, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxtxb"
  }, [_c('span', [_vm._v("Agate and Surrey books are available in bulk at discount prices. For more information, go to "), _c('a', {
    attrs: {
      "href": "http://agatepublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("agatepublishing.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0